import { SVGProps, Ref, forwardRef } from 'react';

export const UserSingleBanFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.667 9.334a3.333 3.333 0 1 1 0 6.666 3.333 3.333 0 0 1 0-6.666m-1.768 2.552a1.9 1.9 0 0 0-.165.781l.01.197a1.933 1.933 0 0 0 1.923 1.736l.197-.01c.206-.021.4-.076.582-.156zm1.768-1.152c-.276 0-.539.058-.776.162l2.544 2.546c.105-.237.165-.499.165-.775l-.01-.197a1.93 1.93 0 0 0-1.726-1.726z"
                fill="currentColor"
            />
            <path
                d="M6.497 10c.71 0 1.419.082 2.089.267a4.7 4.7 0 0 0-.652 2.4c0 .848.224 1.644.615 2.333H.5c.419-3.725 3.207-5 5.997-5"
                fill="currentColor"
            />
            <path d="M6.495 1c3 0 4 2 4 4s-1 4-4 4-4-2-4-4 1-4 4-4" fill="currentColor" />
        </g>
    </svg>
));
UserSingleBanFilledSize16Glyph.displayName = 'UserSingleBanFilledSize16Glyph';
